import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { ApiService } from "app/shared/services/api.service";
import moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import swal from "sweetalert2";

@Component({
  selector: "app-add-update-classbystudent",
  templateUrl: "./add-update-classbystudent.component.html",
  styleUrls: ["./add-update-classbystudent.component.scss"],
})
export class AddUpdateClassbystudentComponent implements OnInit {
  classForm: FormGroup;
  referenceForm: FormGroup;
  reference_id: any
  reference_model = {
    refId: '',
    name: '',
    links: '',
    description: '',
    IP: '',
    notes: '',
    admin_notes: ''
  }
  class_model = {
    instructor: "",
    title: "",
    date: "",
    start_time: "",
    end_time: "",
    notes: "",
    type: "",
    status: "",
    admin_notes: "",
    students: [],
    project_tag: null,
    zoom_link: "",
    references: [],
    pattern_schedule: {
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: false,
      sunday: false
    },

  };
  classByStudentForm: FormGroup;
  dateRange: { startDate: moment.Moment, endDate: moment.Moment };
  selectedDates: string[] = [];
  dateOptions: string[] = [];
  singleDate: string | null = null;   // bound to <input type="date">
  dateList: string[] = [];
  // selectedDates: string[] = [];
  selectedDate: string = '';
  instructor_list: any = [];
  course_list: any = [];
  student_list: any = [];
  class_list: any = [];
  enrollment_list: any = [];
  topic_list: any = [];
  session_list: any = [];
  select_student = null;
  select_enrollment = null;
  select_topic = null;
  select_session = null;
  select_course = null;
  ipAddress: any
  referenceList = [];
  selectedRef: string[] = [];
  status_list = [
    { id: "upcoming", name: "Upcoming" },
    { id: "today", name: "Today" },
    { id: "past", name: "Past" },
  ];
  isStudentSubmit: boolean = false;
  class_id: any;
  class_status: any;
  students_array = [];
  student_obj = {
    student_id: "",
    enrollment_id: "",
    course_id: "",
    session_id: "",
    topic_id: [],
  };
  // Project tag options – now directly use DESK/LIVE as values
  project_tags_list: any[] = [
    { _id: 'DESK', name: 'DESK', displayname: 'DESK' },
    { _id: 'LIVE', name: 'LIVE', displayname: 'LIVE' }
  ];
  selected_channel: any;
  project_tags_tagcat_id = '685971ad7bf67c03258f6740';
  student_id: any;
  radio_button: any = null;
  days = [
    { key: 'sunday', label: 'S' },
    { key: 'monday', label: 'M' },
    { key: 'tuesday', label: 'T' },
    { key: 'wednesday', label: 'W' },
    { key: 'thursday', label: 'T' },
    { key: 'friday', label: 'F' },
    { key: 'saturday', label: 'S' },
  ];


  constructor(
    private formBuilder: FormBuilder,
    public toastr: ToastrService,
    private activatedRoute: ActivatedRoute,

    public apiService: ApiService,
    private route: Router,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService
  ) {
    // Get class_id from route params synchronously
    this.class_id = this.activatedRoute.snapshot.params["id"];

    // Also subscribe for route changes
    this.activatedRoute.params.subscribe((params) => {
      this.class_id = params["id"];
    });
  }

  addDate(): void {
    if (!this.singleDate) { return; }

    const d = this.singleDate;        // already in YYYY‑MM‑DD format
    if (!this.dateList.includes(d)) {
      this.dateList.push(d);
    }

    this.singleDate = null;           // reset input
  }

  removeDate(idx: number): void {
    this.dateList.splice(idx, 1);
  }

  onDateSelected(range: { startDate: moment.Moment; endDate: moment.Moment }): void {
    // Build an array of every day in the chosen span
    const start = range.startDate.clone();
    const end = range.endDate.clone();

    const dates = [];
    for (let m = start; m.isSameOrBefore(end); m.add(1, 'day')) {
      dates.push(m.format('YYYY-MM-DD'));
    }

    this.selectedDates = dates;
    console.log('Selected dates:', this.selectedDates);
  }
  generateNext30Days() {
    const today = new Date();
    for (let i = 0; i < 30; i++) {
      const nextDate = new Date(today);
      nextDate.setDate(today.getDate() + i);
      this.dateOptions.push(nextDate.toISOString().split('T')[0]); // yyyy-MM-dd
    }
  }

  toggleDateSelection(date: string) {
    const index = this.selectedDates.indexOf(date);
    if (index === -1) {
      this.selectedDates.push(date);
    } else {
      this.selectedDates.splice(index, 1);
    }
  }

  submitClasses() {
    for (const date of this.selectedDates) {
      const newClass = {
        ...this.class_model,
        date: date,
      };
      console.log('Creating class for:', newClass);
      // Call your API here to create the class
    }
  }
  ngOnInit(): void {
    this.generateNext30Days();
    this.activatedRoute.queryParams.subscribe(params => {
      this.class_status = params['status'];
      console.log('class_status:', this.class_status);
    });

    // Initialize default values only if not editing
    if (!this.class_id) {
      this.class_model.date = moment(new Date()).format("YYYY-MM-DD");
      this.class_model.instructor = null;
      this.class_model.status = null;
      this.class_model.start_time = "11:00";
      this.class_model.end_time = "13:00";
    }

    this.classByStudentForm = this.formBuilder.group({
      title: ["", Validators.required],
      date: ["", Validators.required],
      start_time: ["", Validators.required],
      end_time: ["", Validators.required],
      notes: [""],
      admin_notes: [""],
      pattern_schedule: this.formBuilder.group({
        monday: [true],
        tuesday: [true],
        wednesday: [true],
        thursday: [true],
        friday: [true],
        saturday: [false],
        sunday: [false],
      }),
    });
    this.referenceForm = this.formBuilder.group({
      name: ['',],
      links: ['',],
      description: ['',],
      IP: ['',],
      notes: ['',],
      admin_notes: ['',]
    });

    // Load all required data - sequential loading to avoid conflicts
    this.loadAllData();
  }

  toggleDay(day: string): void {
    const ctrl = (this.classByStudentForm.get('pattern_schedule') as FormGroup)
      .get(day);
    ctrl?.setValue(!ctrl.value);
  }

  get patternSchedule() {
    return this.classByStudentForm.get('pattern_schedule') as FormGroup;
  }

  async loadAllData() {
    try {
      // Load instructor list first (required for editing)
      await this.getAllInstructorList();

      // Load course list and project tags in parallel (they don't depend on each other)
      this.getCourseList();
      this.getProjectTags();

      // Load class data if editing
      if (this.class_id) {
        console.log('Loading class data for ID:', this.class_id);
        // Small delay to ensure instructor list is ready for dropdown
        setTimeout(() => {
          this.classGetById(this.class_id);
        }, 300);
      }
    } catch (error) {
      console.error('Error loading data:', error);
      this.toastr.error('Failed to initialize form data');
    }
  }
  ngAfterViewInit() {
    this.class_model.date = moment(new Date()).format("YYYY-MM-DD");
  }

  classGetById(id) {
    if (!id) {
      this.toastr.error('Class ID is missing');
      return;
    }

    console.log('Loading class with ID:', id);
    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });

    this.apiService.getClassById(id).subscribe(
      (res: any) => {
        console.log('Class API Response:', res);

        // Check if response has error
        if (res?.error) {
          this.spinner.hide();
          this.toastr.error(res.error || 'Failed to load class data');
          return;
        }

        // Handle different response structures
        let classData = null;
        if (Array.isArray(res?.data) && res.data.length > 0) {
          classData = res.data[0];
        } else if (res?.data && !Array.isArray(res.data)) {
          classData = res.data;
        } else if (res && !res.data) {
          classData = res; // Direct response
        }

        if (!classData) {
          this.spinner.hide();
          this.toastr.error('No class data found');
          console.error('No class data in response:', res);
          return;
        }

        console.log('Class Data:', classData);

        // Update class_model with all fields
        this.class_model = { ...this.class_model, ...classData };

        // Format and set individual fields
        let date: any = classData?.date ? moment(classData.date).format("YYYY-MM-DD") : '';
        this.class_model.date = date;
        this.class_model.title = classData?.title || '';
        this.class_model.start_time = classData?.start_time || '';
        this.class_model.end_time = classData?.end_time || '';
        this.class_model.notes = classData?.notes || '';
        this.class_model.admin_notes = classData?.admin_notes || '';
        this.class_model.status = classData?.status || '';
        this.class_model.instructor = classData?.instructor?._id || null;

        // Safely handle students array - filter out any null/undefined entries
        if (Array.isArray(classData?.students)) {
          this.class_model.students = classData.students.filter((s: any) => s != null);
        } else {
          this.class_model.students = [];
        }

        console.log('Instructor ID:', this.class_model.instructor);
        console.log('Instructor Object:', classData?.instructor);
        console.log('Students loaded:', this.class_model.students.length);

        // Set project tag (supports both old ObjectId-based and new enum string storage)
        if (classData?.project_tag) {
          // New style: simple string enum 'DESK' | 'LIVE'
          if (typeof classData.project_tag === 'string') {
            this.class_model.project_tag = classData.project_tag;
            this.selected_channel = classData.project_tag;
          }
          // Old style: populated tag object with _id
          else if (classData.project_tag._id) {
            this.class_model.project_tag = classData.project_tag._id;
            this.selected_channel = classData.project_tag._id;
          }
        }

        // Set zoom link
        if (classData?.zoom_link) {
          this.class_model.zoom_link = classData.zoom_link;
        }

        // Set references - handle both single and array
        if (classData?.refrences) {
          if (classData.refrences._id) {
            // Single reference object
            this.referenceList = [classData.refrences];
            this.selectedRef = [classData.refrences._id];
            this.class_model.references = [classData.refrences];
          } else if (Array.isArray(classData.refrences) && classData.refrences.length > 0) {
            // Array of references
            this.referenceList = classData.refrences.map((item: any) => item);
            this.selectedRef = this.referenceList.map((item: any) => item?._id).filter(Boolean);
            this.class_model.references = classData.refrences;
          }
        }

        // Set pattern schedule if exists
        if (classData?.pattern_schedule) {
          this.class_model.pattern_schedule = classData.pattern_schedule;
        }

        // Populate form fields
        if (this.classByStudentForm) {
          this.classByStudentForm.patchValue({
            title: this.class_model.title || '',
            date: this.class_model.date || '',
            start_time: this.class_model.start_time || '',
            end_time: this.class_model.end_time || '',
            notes: this.class_model.notes || '',
            admin_notes: this.class_model.admin_notes || '',
            pattern_schedule: this.class_model.pattern_schedule || {
              monday: true,
              tuesday: true,
              wednesday: true,
              thursday: true,
              friday: true,
              saturday: false,
              sunday: false
            }
          });
        }

        this.spinner.hide();

        // Ensure instructor dropdown shows selected value after list is loaded
        setTimeout(() => {
          if (this.class_model.instructor && this.instructor_list.length > 0) {
            console.log('Instructor set:', this.class_model.instructor);
            console.log('Instructor list loaded:', this.instructor_list.length);
          } else {
            console.warn('Instructor not set or list not loaded:', {
              instructor: this.class_model.instructor,
              listLength: this.instructor_list.length
            });
          }
        }, 500);
      },
      (error) => {
        this.spinner.hide();
        console.error('Error loading class:', error);
        const errorMessage = error?.error?.message || error?.message || 'Failed to load class data';
        this.toastr.error(errorMessage);
      }
    );
  }
  getAllInstructorList(): Promise<void> {
    return new Promise((resolve, reject) => {
      console.log('Loading instructor list...');

      // Add timeout to prevent hanging
      const timeout = setTimeout(() => {
        console.error('Instructor list request timed out');
        this.toastr.error('Request timeout: Failed to load instructors. Please check your connection.');
        this.instructor_list = [];
        resolve(); // Resolve anyway to continue
      }, 30000); // 30 second timeout

      this.apiService.getEmployeeList(1, 100).subscribe(
        (res: any) => {
          clearTimeout(timeout);
          console.log('Instructor list response:', res);

          // Check if response is an error object
          if (res && typeof res === 'object' && (res.error || res.message || res.statusCode !== 200)) {
            console.error('Error in instructor response:', res);
            const errorMsg = res.error || res.message || 'Failed to load instructors';
            this.toastr.error(errorMsg);
            this.instructor_list = [];
            resolve();
            return;
          }

          // Extract items from response
          this.instructor_list = res?.items || res?.data?.items || res?.data || [];

          if (this.instructor_list.length === 0) {
            console.warn('Instructor list is empty');
          } else {
            console.log('Instructor list loaded successfully:', this.instructor_list.length, 'items');
          }

          resolve();
        },
        (error) => {
          clearTimeout(timeout);
          console.error('Error loading instructors:', error);
          const errorMsg = error?.error?.message || error?.message || error?.error || 'Failed to load instructors';
          this.toastr.error(errorMsg);
          this.instructor_list = [];
          resolve(); // Resolve anyway to continue
        }
      );
    });
  }
  getAllStudents() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAllEnrollStudents(1, 10000).subscribe((res: any) => {
      this.spinner.hide()
      this.student_list = res?.items;
    });
  }

  getAllPatternClasses() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAllPatternClass(1, 10, false).subscribe((res: any) => {
      this.spinner.hide()
      this.class_list = res?.data?.items;
      console.log('class_list', this.class_list)
    });
  }
  getInstructorId(event) {
    this.class_model.instructor;
  }
  getStatusId(event) {
    this.class_model.status;
  }
  getCourseList() {
    console.log('Loading course list...');

    // Add timeout
    const timeout = setTimeout(() => {
      console.error('Course list request timed out');
      this.toastr.error('Request timeout: Failed to load course list');
      this.course_list = [];
    }, 30000); // 30 second timeout

    this.apiService.getCourseList(1, 1000).subscribe(
      (res: any) => {
        clearTimeout(timeout);
        console.log('Course list response:', res);

        // Check if response is an error object
        if (res && typeof res === 'object' && (res.error || res.message)) {
          console.error('Error in course list response:', res);
          this.course_list = [];
          return;
        }

        this.course_list = res?.data?.items || res?.items || res?.data || [];
        console.log('Course list loaded:', this.course_list.length);
      },
      (error) => {
        clearTimeout(timeout);
        console.error('Error loading course list:', error);
        this.course_list = [];
      }
    );
  }
  getChangeChannelId(event) {
    // Ensure we're using the actual tag object's _id, not a string
    if (event && typeof event === 'object' && event._id) {
      this.class_model.project_tag = event._id;
      this.selected_channel = event._id;
    } else if (this.selected_channel) {
      // If selected_channel is already set, use it (should be ObjectId)
      this.class_model.project_tag = this.selected_channel;
    }

    // Clear zoom link if DESK is selected
    if (!this.isLiveSelected()) {
      this.class_model.zoom_link = '';
    }

    console.log('Selected project tag:', this.class_model.project_tag);
  }

  isLiveSelected(): boolean {
    if (!this.selected_channel || !this.project_tags_list.length) {
      return false;
    }
    const selectedTag = this.project_tags_list.find(tag => tag._id === this.selected_channel);
    const tagName = selectedTag?.name?.toUpperCase() || selectedTag?.displayname?.toUpperCase() || '';
    return tagName === 'LIVE';
  }

  getProjectTags() {
    console.log('Loading project tags - filtering for LIVE and DESK only');
    console.log('Category ID:', this.project_tags_tagcat_id);

    if (!this.project_tags_tagcat_id) {
      console.error('❌ Category ID is missing! Using static tags');
      // Use static tags as fallback - they are already initialized
      return;
    }

    this.apiService.getTagByTagCatgoryId(this.project_tags_tagcat_id).subscribe(
      (res: any) => {
        try {
          console.log('🔍 API Response Type:', typeof res);
          console.log('🔍 API Response:', res);

          // Check for errors first
          if (res?.error) {
            console.error('❌ API Error:', res.error);
            // On error, use static tags as fallback
            console.warn('⚠️ API returned error. Using static LIVE/DESK tags as fallback');
            this.project_tags_list = [
              { _id: 'LIVE_STATIC', name: 'LIVE', displayname: 'LIVE' },
              { _id: 'DESK_STATIC', name: 'DESK', displayname: 'DESK' }
            ];
            return;
          }

          // Extract tags array from response - handle multiple formats
          let allTags: any[] = [];

          if (Array.isArray(res)) {
            // Response is directly an array
            allTags = res;
            console.log('✅ Response is array:', allTags.length, 'tags');
          } else if (res?.data) {
            if (Array.isArray(res.data)) {
              // Response format: { data: [...] }
              allTags = res.data;
              console.log('✅ Tags in res.data:', allTags.length, 'tags');
            } else if (typeof res.data === 'object') {
              // Try to find array in data object
              const values = Object.values(res.data);
              const arrays = values.filter(v => Array.isArray(v)) as any[][];
              if (arrays.length > 0) {
                allTags = arrays[0];
                console.log('✅ Tags in nested data:', allTags.length, 'tags');
              }
            }
          }

          console.log('📊 Total tags extracted:', allTags.length);

          if (allTags.length > 0) {
            // Log all tag names for debugging
            const tagNames = allTags.map(t => t?.name || t?.displayname || 'N/A').filter(Boolean);
            console.log('🏷️ All available tag names:', tagNames.join(', '));
          }

          // Filter for LIVE and DESK tags
          const filteredTags = allTags.filter((tag: any) => {
            if (!tag) return false;
            const name = String(tag.name || '').toUpperCase().trim();
            const displayname = String(tag.displayname || '').toUpperCase().trim();
            return name === 'LIVE' || name === 'DESK' || displayname === 'LIVE' || displayname === 'DESK';
          });

          console.log('🔍 Filtered LIVE/DESK tags:', filteredTags.length);

          if (filteredTags.length > 0) {
            // Found LIVE/DESK tags from API - use them
            this.project_tags_list = filteredTags;
            console.log('✅ Using LIVE/DESK tags from API:', filteredTags.map((t: any) => t?.name || t?.displayname));
          } else {
            // No LIVE/DESK tags found from API - use static tags as fallback
            console.warn('⚠️ LIVE/DESK not found in API. Using static tags as fallback');
            this.project_tags_list = [
              { _id: 'LIVE_STATIC', name: 'LIVE', displayname: 'LIVE' },
              { _id: 'DESK_STATIC', name: 'DESK', displayname: 'DESK' }
            ];
            console.log('✅ Using static LIVE/DESK tags');
          }
        } catch (err) {
          console.error('❌ Error processing tags:', err);
          // On error, use static tags as fallback
          console.warn('⚠️ Error processing. Using static LIVE/DESK tags as fallback');
          this.project_tags_list = [
            { _id: 'LIVE_STATIC', name: 'LIVE', displayname: 'LIVE' },
            { _id: 'DESK_STATIC', name: 'DESK', displayname: 'DESK' }
          ];
        }
      },
      (error) => {
        console.error('❌ API Error:', error);
        // On error, use static tags as fallback
        console.warn('⚠️ API failed. Using static LIVE/DESK tags as fallback');
        this.project_tags_list = [
          { _id: 'LIVE_STATIC', name: 'LIVE', displayname: 'LIVE' },
          { _id: 'DESK_STATIC', name: 'DESK', displayname: 'DESK' }
        ];
        console.log('✅ Using static LIVE/DESK tags');
      }
    );
  }

  getRefId(event) {
    if (!this.class_id) {
      this.selectedRef
      this.class_model.references = event
    }
    if (this.class_id) {
      this.class_model.references = event
      let data = this.class_model.references.filter(obj => !('_id' in obj));
      if (data) {
        this.class_model.references = data
        const newValues = event.filter(value => !this.class_model.references.some(obj => obj._id === value._id))
        this.class_model.references.push(...newValues)
      }
    }
  }
  getCourseId(event) {
    this.select_course;
    this.getPendingTopics(this.select_course, this.select_student);
  }
  getSessionsList(id) {
    this.apiService.getSessionsByCourseId(id).subscribe((res: any) => {
      this.session_list = res?.data;
    });
  }
  getSessionId(event) {
    this.select_session;
    let topic = this.select_session.topic_id.map(item => item._id)
    let topicname = this.select_session.topic_id.map((item) => item.name);
    this.student_obj.topic_id.push(topicname);
    this.select_topic = topic
  }
  getStudentId(event) {
    this.student_obj.student_id = event.name;
    this.select_student;
    this.getEnrollmentByStudent(this.select_student);
  }
  getEnrollmentByStudent(id) {
    if (id) {
      this.apiService.getEnrolmentByUserId(id).subscribe((res: any) => {
        this.enrollment_list = res?.data?.map((item) => item);
        this.select_enrollment = this.enrollment_list[0]._id;
        this.select_course = this.enrollment_list[0].course_id;
        if (this.select_course) {
          this.getPendingTopics(this.select_course, this.select_student);
          this.getSessionsList(this.select_course);
        }
      });
    }
  }
  getEnrollmentId(event) {
    this.select_enrollment;
  }
  getTopicId(event) {
    this.select_topic;
    if (event) {
      let topic = event.map((item) => item.topic_name);
      this.student_obj.topic_id.push(topic);
    }

  }
  getPendingTopics(course, student) {
    this.apiService.getPendingTopicByUserId(course, student, '', 'student').subscribe((res: any) => {
      this.topic_list = res?.data
      this.select_topic = this.topic_list.map((item) => item.topic_id);
      let topic = this.topic_list.map((item) => item.topic_name);
      this.student_obj.topic_id.push(topic);
    })
  }
  getTopicList(id) {
    this.apiService.getTopicsByCourseId(id).subscribe((res: any) => {
      if (res.statusCode === 200) {
        const extractedData = res?.data.map((item) => {
          return item.data.flatMap((subArray) => {
            return subArray.flatMap((innerArray) => {
              return innerArray.map((obj) => {
                return {
                  name: obj.name,
                  _id: obj._id,
                };
              });
            });
          });
        });
        this.topic_list = extractedData.flat();
      }
    });
  }

  back() {
    this.route.navigate(["/classes/list"]);
  }
  addStudentPopup(content) {
    const modalOptions: NgbModalOptions = {
      size: "lg",
    };
    const modalRef = this.modalService.open(content, modalOptions);
    modalRef.result.then(
      (result) => {
        // console.log(`Modal closed with result: ${result}`);
      },
      (reason) => { }
    );
  }
  editStudentPopup(content, data) {
    console.log('Edit student data:', data);
    
    this.select_student = data?.student_info?._id;
    this.select_course = data?.course_info?._id;
    this.select_enrollment = data?.enrollment_info?._id;
    this.select_session = data?.session_info?.[0]?._id;
    this.select_topic = data?.topic_info?.map((item) => item._id);

    // Set radio button based on whether session exists
    if (this.select_session) {
      this.radio_button = 'Session Wise';
    } else if (this.select_topic && this.select_topic.length > 0) {
      this.radio_button = 'Topic Wise';
    }

    // Load the topic list for the selected course
    if (this.select_course) {
      this.getTopicList(this.select_course);
      this.getSessionsList(this.select_course);
    }

    // Load enrollment list for the selected student
    if (this.select_student) {
      this.getEnrollmentByStudent(this.select_student);
    }

    const modalOptions: NgbModalOptions = {
      size: "lg",
    };
    const modalRef = this.modalService.open(content, modalOptions);
    modalRef.result.then(
      (result) => {
        // Reset all selections when modal closes
        this.select_student = null;
        this.select_enrollment = null;
        this.select_session = null;
        this.select_topic = null;
        this.select_course = null;
        this.radio_button = null;
      },
      (reason) => {
        // Reset all selections when modal is dismissed
        this.select_student = null;
        this.select_enrollment = null;
        this.select_session = null;
        this.select_topic = null;
        this.select_course = null;
        this.radio_button = null;
      }
    );
  }
  addStudent() {
    let session = this.select_session ? this.select_session._id : '';
    let obj = {
      student_id: this.select_student,
      enrolment_id: this.select_enrollment,
      topic_id: this.select_topic,
      course_id: this.select_course,
      ...(session && { session_id: session }),
    };
    this.class_model.students.push(obj);
    this.students_array.push(this.student_obj);
    this.student_obj = {
      student_id: "",
      enrollment_id: "",
      course_id: "",
      session_id: "",
      topic_id: [],
    };
    this.select_student = null;
    this.select_enrollment = null;
    this.select_topic = null;
    this.select_session = null;
    this.select_course = null;
    this.isStudentSubmit = true;
  }

  handleSubmit(): void {
    // pattern → create multiple classes
    if (this.class_status === 'pattern') {
      this.classsubmit();
      return;
    }

    // everything else → old single‑class flow
    this.submit();
  }

  submit() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    if (!this.class_id) {
      // Validate zoom_link if LIVE is selected
      if (this.isLiveSelected() && !this.class_model.zoom_link?.trim()) {
        this.toastr.warning('Please enter Zoom Link for LIVE classes');
        this.spinner.hide();
        return;
      }

      // Get the actual ObjectId from selected_channel (not the name)
      const projectTagValue = this.selected_channel || this.class_model?.project_tag || null;

      let model: any = {
        instructor: this.class_model.instructor,
        title: this.classByStudentForm.value.title,
        date: moment(this.class_model.date).format("YYYY-MM-DD"),
        start_time: this.classByStudentForm.value.start_time,
        end_time: this.classByStudentForm.value.end_time,
        notes: this.classByStudentForm.value.notes,
        type: "student",
        status: this.class_model.status,
        admin_notes: this.classByStudentForm.value.admin_notes,
        students: this.class_model.students,
        project_tag: projectTagValue,
        references: this.class_model.references,
      };

      // Add zoom_link only if LIVE is selected
      if (this.isLiveSelected() && this.class_model.zoom_link?.trim()) {
        model.zoom_link = this.class_model.zoom_link.trim();
      }

      this.apiService.createClass(model).subscribe((res: any) => {
        if (res?.isSuccess) {
          this.spinner.hide();
          this.toastr.success("Class created successfully");
          this.modalService.dismissAll();
          this.route.navigate(["/classes/list"]);
        } else {
          this.spinner.hide();
          this.toastr.error(res?.error);
        }
      });
    }

    if (this.class_id) {
      this.apiService
        .updateClass(this.class_id, this.class_model)
        .subscribe((res: any) => {
          if (res?.isSuccess) {
            this.spinner.hide();
            this.modalService.dismissAll();
            this.toastr.success("Class update successfully");
            this.route.navigate(["/classes/list"]);
          } else {
            this.spinner.hide();
            this.toastr.error(res?.error);
          }
        });
    }
  }
  classsubmit() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    if (!this.class_id) {
      // Validate zoom_link if LIVE is selected
      if (this.isLiveSelected() && !this.class_model.zoom_link?.trim()) {
        this.toastr.warning('Please enter Zoom Link for LIVE classes');
        this.spinner.hide();
        return;
      }

      // Get the actual ObjectId from selected_channel (not the name)
      const projectTagValue = this.selected_channel || this.class_model?.project_tag || null;

      let model: any = {
        instructor: this.class_model.instructor,
        title: this.classByStudentForm.value.title,
        dates: this.dateList,
        start_time: this.classByStudentForm.value.start_time,
        end_time: this.classByStudentForm.value.end_time,
        notes: this.classByStudentForm.value.notes,
        type: "student",
        status: this.class_model.status,
        admin_notes: this.classByStudentForm.value.admin_notes,
        students: this.class_model.students,
        project_tag: projectTagValue,
        references: this.class_model.references,
        pattern_schedule: this.classByStudentForm.value.pattern_schedule,
      };

      // Add zoom_link only if LIVE is selected
      if (this.isLiveSelected() && this.class_model.zoom_link?.trim()) {
        model.zoom_link = this.class_model.zoom_link.trim();
      }

      this.apiService.createmultipleClass(model).subscribe((res: any) => {
        if (res?.isSuccess) {
          this.spinner.hide();
          this.toastr.success("Class created successfully");
          this.modalService.dismissAll();
          const queryParams = { status: 'pattern' };
          console.log('queryParams', queryParams)
          this.route.navigate(["/classes/list"], { queryParams });
        } else {
          this.spinner.hide();
          this.toastr.error(res?.error);
        }
      });
    }

    if (this.class_id) {
      this.apiService
        .updateClass(this.class_id, this.class_model)
        .subscribe((res: any) => {
          if (res?.isSuccess) {
            this.spinner.hide();
            this.modalService.dismissAll();
            this.toastr.success("Class update successfully");
            this.route.navigate(["/classes/list"]);
          } else {
            this.spinner.hide();
            this.toastr.error(res?.error);
          }
        });
    }
  }
  updateStudent() {
    if (!this.select_student) {
      this.toastr.error('Please select a student');
      return;
    }

    if (!this.select_enrollment) {
      this.toastr.error('Please select an enrollment');
      return;
    }

    if (!this.select_topic || this.select_topic.length === 0) {
      this.toastr.error('Please select at least one topic');
      return;
    }

    let body = {
      students: [
        {
          enrolment_id: this.select_enrollment,
          topic_id: this.select_topic,
          session_id: this.select_session || null,
          course_id: this.select_course,
        },
      ],
    };

    if (this.class_id && this.select_student) {
      this.spinner.show(undefined, {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });

      this.apiService
        .updateClassStudent(this.class_id, this.select_student, body)
        .subscribe(
          (res: any) => {
            this.spinner.hide();
            if (res?.isSuccess) {
              this.modalService.dismissAll();
              this.toastr.success("Student updated successfully");
              // Reset selections
              this.select_student = null;
              this.select_enrollment = null;
              this.select_session = null;
              this.select_topic = null;
              this.select_course = null;
              this.radio_button = null;
              // Refresh the class data
              this.classGetById(this.class_id);
            } else {
              this.toastr.error(res?.error || 'Failed to update student');
            }
          },
          (error) => {
            this.spinner.hide();
            console.error('Error updating student:', error);
            this.toastr.error(error?.error?.message || error?.message || 'Failed to update student');
          }
        );
    }
  }
  openModal(content) {
    this.reference_model.IP = this.ipAddress
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  submitRef() {

    this.referenceForm = this.formBuilder.group(this.reference_model);
    this.referenceList.push(this.referenceForm.value)
    this.referenceList = this.referenceList.map(item => item)
    this.referenceForm.reset(this.reference_model);
    this.modalService.dismissAll()
  }

  editItem(data, content) {
    this.reference_id = data._id
    this.reference_model.refId = this.reference_id
    this.reference_model.name = data.name
    this.reference_model.links = data.links
    this.reference_model.description = data.description
    this.reference_model.notes = data.notes
    this.reference_model.admin_notes = data.admin_notes
    this.reference_model.IP = data.IP
    this.class_id = data.class_id
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  deleteStudent(index) {
    this.class_model.students.splice(index, 1);
    this.students_array.splice(index, 1);
  }
  
  deleteStudentFromClass(studentId: any, index: number) {
    if (!studentId || !this.class_id) {
      this.toastr.error('Student ID or Class ID is missing');
      return;
    }

    swal
      .fire({
        title: "Are you sure?",
        text: "You want to delete this student from the class?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#2F8BE6",
        cancelButtonColor: "#F55252",
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-warning",
          cancelButton: "btn btn-danger ml-1",
        },
        buttonsStyling: false,
      })
      .then((result) => {
        if (result.value) {
          this.spinner.show(undefined, {
            type: 'ball-triangle-path',
            size: 'medium',
            bdColor: 'rgba(0, 0, 0, 0.8)',
            color: '#fff',
            fullScreen: true
          });

          this.apiService
            .deleteStudentFromClass(studentId, this.class_id)
            .subscribe((res: any) => {
              this.spinner.hide();
              if (res?.isSuccess) {
                swal.fire({
                  icon: "success",
                  title: "Deleted",
                  text: "Student deleted successfully from the class.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
                // Refresh the class data to update the table
                this.classGetById(this.class_id);
              } else {
                swal.fire({
                  icon: "error",
                  title: "Error",
                  text: `${res.error || 'Failed to delete student'}`,
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
              }
            }, (error) => {
              this.spinner.hide();
              swal.fire({
                icon: "error",
                title: "Error",
                text: error?.error?.message || error?.message || 'Failed to delete student',
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            });
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            text: "Student is safe in the class :)",
            icon: "info",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }

  isClassIdSet(): boolean {
    return this.class_id;
  }
  getRadioValue(event) {
    this.radio_button = event.target.value
  }
}
